import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { marginOf } from "@/components/AdminProductDetails";

export const lowMargin = (p, threshold) => {
  const m = marginOf(p);
  return m != null && m < threshold;
};

export const LowMarginPanel = ({ products, threshold, onThreshold }) => {
  const [value, setValue] = useState(String(threshold));
  useEffect(() => setValue(String(threshold)), [threshold]);
  const low = products.filter((p) => p.active && lowMargin(p, threshold)).sort((a, b) => marginOf(a) - marginOf(b));
  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/admin/settings", { margin_alert: Number(value) });
      onThreshold(data.margin_alert);
      toast.success(`Alert level set to ${data.margin_alert}%`);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <section data-testid={ADMIN.lowMargin} className={`mt-4 rounded-[1.5rem] p-5 text-sm border ${low.length ? "bg-amber-50 border-amber-200" : "bg-white border-[#F0EBE1]"}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="font-heading font-bold text-base">
          {low.length ? `${low.length} product${low.length === 1 ? "" : "s"} below your margin alert` : "All priced products are above your margin alert"}
        </p>
        <form onSubmit={save} className="flex items-center gap-2">
          <label htmlFor="margin-alert" className="text-stone-600">Warn me below</label>
          <input id="margin-alert" data-testid={ADMIN.marginThreshold} type="number" min="0" max="100" step="1" required value={value} onChange={(e) => setValue(e.target.value)} className="w-20 px-3 py-1.5 rounded-xl border border-[#E7E0D3] bg-white" />
          <span>%</span>
          <button data-testid={ADMIN.marginSave} disabled={Number(value) === threshold} className="px-4 py-1.5 rounded-full bg-[#1C1917] text-white disabled:opacity-40 hover:bg-[#E06D44] transition-colors">Save</button>
        </form>
      </div>
      {low.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {low.map((p) => (
            <li key={p.slug} data-testid={ADMIN.lowMarginRow(p.slug)} className="flex justify-between gap-3">
              <span className="truncate">{p.name}</span>
              <span className="whitespace-nowrap text-amber-800">{marginOf(p).toFixed(0)}% · sells {money(p.price)}, costs {money(Number(p.cost) + Number(p.ship_cost || 0))}</span>
            </li>
          ))}
        </ul>
      )}
      <p className="mt-3 text-xs text-stone-500">Margin = price − product cost − shipping cost, before payment fees. Products without a cost aren't checked.</p>
    </section>
  );
};
